import { RECEPTOR_MODEL_IDS } from 'src/pages/AccountSettings/grid/AccountSettingsGrid.constants'
import { GridColumnSortFrameworks } from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'

export const FRAMEWORKS_PAGE_SIZE = 20

/** Query param `tab=` values for the framework show page. */
export const FRAMEWORK_SHOW_TAB = Object.freeze({
  REQUIREMENTS: 'requirements',
  CONTROLS: 'controls',
  AUDITS: 'audits',
})

export const FRAMEWORKS_HEADERS = Object.freeze({
  LOGO: '',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  REQUIREMENTS: 'Requirements',
  CONTROLS: 'Controls',
  AUDITS: 'Audits',
  MENU: '',
})

export const FRAMEWORKS_HEADERS_TO_SORT_COL: Record<
  string,
  GridColumnSortFrameworks | undefined
> = {
  [FRAMEWORKS_HEADERS.NAME]: GridColumnSortFrameworks.NAME,
  [FRAMEWORKS_HEADERS.DESCRIPTION]: GridColumnSortFrameworks.DESCRIPTION,
  [FRAMEWORKS_HEADERS.REQUIREMENTS]: GridColumnSortFrameworks.REQUIREMENTS,
  [FRAMEWORKS_HEADERS.CONTROLS]: GridColumnSortFrameworks.CONTROLS,
  [FRAMEWORKS_HEADERS.AUDITS]: GridColumnSortFrameworks.AUDITS,
}

export const GRC_RECEPTOR_DISPLAY_NAMES: Record<string, string> = {
  [RECEPTOR_MODEL_IDS.ARCHER]: 'Archer',
  [RECEPTOR_MODEL_IDS.ANECDOTES]: 'Anecdotes',
}

export const GRC_RECEPTOR_MODEL_IDS: ReadonlySet<string> = new Set(
  Object.keys(GRC_RECEPTOR_DISPLAY_NAMES),
)
